module.exports = __webpack_public_path__ + "img/planet-rock.1d4cdf23.png";